// export const apiURL = 'http://localhost:5001/'
export const apiURL = 'https://quiz-blog-rw.herokuapp.com/'